/**
 * Device detection utilities.
 * Centralized detection for mobile, iOS, and Android devices.
 * All device checks should use these functions to avoid duplication.
 */

export const isMobile = () => {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ||
        (navigator.maxTouchPoints && navigator.maxTouchPoints > 2) ||
        window.innerWidth <= 768;
};

export const isIOS = () => {
    return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
};

export const isAndroid = () => {
    return /Android/i.test(navigator.userAgent);
};
